<template>
  <div class="file-box-success">
    <div class="file-box-success__icon">
      <svg-loader src="/static/images/icon-attachment-clip.svg" />
    </div>
    <div class="file-box-success__fileName">
      <p>{{ fileName }}</p>
    </div>
    <div class="file-box-success__action">
      <div 
        class="file-box-success__download"
        @click="pendencyDownloadFileUploaded({fileId, pendencyId})"
      >
        <div class="icon-eye-alt" />
        <md-tooltip md-direction="top">
          Visualizar
        </md-tooltip>
      </div>
      <div
        v-if="deleteBtnEnabled"
        class="file-box-success__delete"
        @click="deletePendencyFile({fileId, pendencyId})"
      >
        <div class="icon-delete-alt" />
        <md-tooltip md-direction="top">
          Excluir
        </md-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FileBoxSuccess',
  props: {
    fileName: {
      type: String,
      default: 'Documento anexo'
    },
    fileId: {
      default: ''
    },
    pendencyId: {
      default: ''
    },
    deleteBtnEnabled: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions([
      'deletePendencyFile',
      'pendencyDownloadFileUploaded'
    ])
  }
}
</script>

<style lang="scss">
.file-box-success {
  display: flex;
  background-color: white;
  border-radius: 4px;
  height: 52px;
  align-items: center;
  padding: 0 1em 0 0.6em;

  &__icon,
  &__download,
  &__delete {
    flex: 1;
    align-content: center;
    display: flex;
  }
  &__action {
    display: flex;
  }
  &__delete {
  margin-left: 7px;
  }
  &__icon {
    svg {
      height: 16px;
      width: 16px;
    }
  }

  &__fileName {
    flex: 6;

    p {
      margin: 0;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 12px;
      letter-spacing: 1.33px;
      color: #7a7a7a;
    }
  }
}
</style>

